import { FC } from 'react';
import { Table } from 'antd';
import { SummaryProps } from 'rc-table/lib/Footer/Summary';
import { SummaryCellProps } from 'rc-table/lib/Footer/Cell';
import { FooterRowProps } from 'rc-table/lib/Footer/Row';
export type { SummaryCellProps };

const ProTableSummary: FC<SummaryProps> = props => {
  const { children, ...resProps } = props;
  return (
    <Table.Summary {...resProps} fixed>
      {children}
    </Table.Summary>
  );
};

const ProTableSummaryCell: FC<SummaryCellProps> = props => {
  const { children, ...resProps } = props;
  return <Table.Summary.Cell {...resProps}>{children}</Table.Summary.Cell>;
};

const ProTableSummaryRow: FC<FooterRowProps> = props => {
  const { children, ...resProps } = props;
  return <Table.Summary.Row {...resProps}>{children}</Table.Summary.Row>;
};

export type ITableSummaryComponent = FC<SummaryProps> & {
  Cell: FC<SummaryCellProps>;
  Row: FC<FooterRowProps>;
};

const TableSummary = ProTableSummary as ITableSummaryComponent;
TableSummary.Cell = ProTableSummaryCell;
TableSummary.Row = ProTableSummaryRow;

export default TableSummary;
